<template>
  <div class="tabbar">
    <a :class="['item', { 'active': active === 'home' }]" @click="goView">
      <img class="icon icon-default" src="./assets/tabbar/icon-home.png" alt="">
      <img class="icon icon-active" src="./assets/tabbar/icon-home-active.png" alt="">
      首页
    </a>
    <a :class="['item', { 'active': active === 'my' }]" @click="$router.push('/my')">
      <img class="icon icon-default" src="./assets/tabbar/icon-my.png" alt="">
      <img class="icon icon-active" src="./assets/tabbar/icon-my-active.png" alt="">
    我的</a>
  </div>
</template>
<script>
export default {
  name: 'Tabbar',
  props: {
    active: {
      type: String,
      default: 'home'
    }
  },
  data () {
    return {
      isLeader: true,
      applicant: false,
      routerUrl: '/'
    }
  },
  created () {
    let jurisdiction = JSON.parse(this.$cookies.get('jurisdiction'))
    if (jurisdiction.length > 0) {
      for (let i = 0; i < jurisdiction.length; i++) {
        if (jurisdiction[i] === 'catering') {
          this.routerUrl = '/approve/each-principal'
          break
        }
        if (jurisdiction[i] === 'hotel') {
          this.routerUrl = '/approve/each-principal'
          break
        }
        if (jurisdiction[i] === 'room') {
          this.routerUrl = '/approve/each-principal'
          break
        }
        if (jurisdiction[i] === 'leader') {
          this.routerUrl = '/approve/direct-lead'
          break
        }
        if (jurisdiction[i] === 'park_leader') {
          this.routerUrl = '/approve/garden'
          break
        }
        if (jurisdiction[i] === 'roomExecutor' || jurisdiction[i] === 'hotelExecutor' || jurisdiction[i] === 'cateringExecutor') {
          this.routerUrl = '/executor/approve'
          break
        }
        if (jurisdiction[i] === 'applicant') {
          for (let j = 0; j < jurisdiction.length; j++) {
            if (jurisdiction[i] === 'park_leader') {
              this.routerUrl = '/approve/garden'
              break
            } else if (jurisdiction[i] === 'catering' || jurisdiction[i] === 'hotel' || jurisdiction[i] === 'room') {
              this.routerUrl = '/approve/each-principal'
              break
            } else if (jurisdiction[i] === 'leader') {
              this.routerUrl = '/approve/direct-lead'
              break
            } else if (jurisdiction[i] === 'roomExecutor' || jurisdiction[i] === 'hotelExecutor' || jurisdiction[i] === 'cateringExecutor') {
              this.routerUrl = '/executor/approve'
              break
            } else {
              this.routerUrl = '/approve/applicant'
              break
            }
          }
        }
      }
    } else {
      this.routerUrl = '/ordinarystaff/my'
    }
    // jurisdiction.forEach(item => {
    //   if (item === 'catering' || item === 'hotel' || item === 'room') {
    //     this.routerUrl = '/approve/each-principal'
    //   } else if (item === 'leader') {
    //     this.routerUrl = '/approve/direct-lead'
    //   } else if (item === 'park_leader') {
    //     this.routerUrl = '/approve/garden'
    //   } else if (item === 'applicant') {
    //     this.routerUrl = '/approve/applicant'
    //   } else {
    //     this.routerUrl = '/ordinarystaff/train'
    //   }
    // })
  },
  methods: {
    goView () {
      this.$router.push(this.routerUrl)
    }
  }
}
</script>
<style lang="scss" scoped>
$height: 49px;
.tabbar
{
  flex: 0 0 $height;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
  .item
  {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #9D9D9D;
    font-size: 11px;
    .icon
    {
      width: 24px;
      height: 24px;
    }
    .icon-default
    {
      display: block;
    }
    .icon-active
    {
      display: none;
    }
    &.active
    {
      .icon-default
      {
        display: none;
      }
      .icon-active
      {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/tabbar.vue